import { createAction } from "@reduxjs/toolkit";
import { OrganizationId } from "@Store/Organizations/types";
import {
  IOrgUserUpdateRequest,
  IUserUpdateRequestActionPayload,
} from "./types";

export const userUpdateRequestsListRequest = createAction<OrganizationId>(
  "USER_UPDATE_REQUESTS_LIST/REQUEST"
);
export const userUpdateRequestsListSuccess = createAction<
  IOrgUserUpdateRequest[]
>("USER_UPDATE_REQUESTS_LIST/SUCCESS");
export const userUpdateRequestsListFail = createAction<Error>(
  "USER_UPDATE_REQUESTS_LIST/FAIL"
);

export const approveUserUpdateRequest = createAction<IUserUpdateRequestActionPayload>(
  "APPROVE_USER_UPDATE_REQUEST/REQUEST"
);
export const approveUserUpdateRequestSuccess =
  createAction<IUserUpdateRequestActionPayload>(
    "APPROVE_USER_UPDATE_REQUEST/SUCCESS"
  );
export const approveUserUpdateRequestFail = createAction<Error>(
  "APPROVE_USER_UPDATE_REQUEST/FAIL"
);

export const declineUserUpdateRequest = createAction<IUserUpdateRequestActionPayload>(
  "DECLINE_USER_UPDATE_REQUEST/REQUEST"
);
export const declineUserUpdateRequestSuccess =
  createAction<IUserUpdateRequestActionPayload>(
    "DECLINE_USER_UPDATE_REQUEST/SUCCESS"
  );
export const declineUserUpdateRequestFail = createAction<Error>(
  "DECLINE_USER_UPDATE_REQUEST/FAIL"
);

export const setHasPendingRequest = createAction<boolean>(
  "SET_HAS_PENDING_REQUEST"
);
